import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/order-webhooks")({
  component: lazyRouteComponent(() => import("./-pages/admin.order-webhooks")),
  head: () => ({
    meta: [
      { title: "طلبات Shopify ومراحل الـWebhooks · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
